const VIEWBOX_X=80,VIEWBOX_Y=240,VIEWBOX_W=660,VIEWBOX_H_BASE=395;
const SVG_TO_MM=300/660,MM_TO_SVG=660/300;
const NAME_CENTER_X=420,NAME_BASE_Y=505,BASE_NAME_FS=178;
const CLASS_DEFAULT_DY=130;
const GRAD1_DEFAULT_DX=11;
const CLASS_DEFAULT_DX=17.46;

// Pick top (y=558) overlaps class2026 bottom (y≈563.7) by ~5.7 units — guaranteed
// single connected cut piece. Pick follows yearDY so it stays locked to the band.
const STAKE_PATH="M396.25,553.0 v102.004 l12.95,17.437 c0.534,0.719,1.758,0.707,2.273,-0.023 L423.75,655.004 V553.0 H396.25 Z";
const STAKE_TIP_OFFSET=119.441; // distance from stake top to tip (102.004+17.437)

const GRAD1_PATH=document.getElementById('grad1Path').getAttribute('d');
const CLASS2026_PATH=document.querySelector('#class2026Group path').getAttribute('d');

let state={szPct:100,letterSpacing:-15,offsetY:0,nameDX:0,yearDY:CLASS_DEFAULT_DY,grDX:0,fontId:'cinzel',stakeOn:false};
let fonts={cinzel:null,sans:null};

const _paperCanvas=document.createElement('canvas');
_paperCanvas.width=800; _paperCanvas.height=800;
paper.setup(_paperCanvas);

const CINZEL_URLS=[
  'https://cdn.jsdelivr.net/npm/@fontsource/cinzel@5.0.3/files/cinzel-latin-700-normal.woff',
  'https://cdn.jsdelivr.net/npm/@fontsource/cinzel@5.0.0/files/cinzel-latin-700-normal.woff',
  'https://cdn.jsdelivr.net/npm/@fontsource/cinzel@4.5.0/files/cinzel-latin-700-normal.woff',
  'https://unpkg.com/@fontsource/cinzel@5.0.3/files/cinzel-latin-700-normal.woff',
  'https://unpkg.com/@fontsource/cinzel@4.5.0/files/cinzel-latin-700-normal.woff',
];
const SANS_URLS=[
  'https://cdn.jsdelivr.net/npm/@fontsource/barlow-condensed@5.0.1/files/barlow-condensed-latin-700-normal.woff',
  'https://cdn.jsdelivr.net/npm/@fontsource/barlow-condensed@4.5.0/files/barlow-condensed-latin-700-normal.woff',
  'https://unpkg.com/@fontsource/barlow-condensed@5.0.1/files/barlow-condensed-latin-700-normal.woff',
  'https://unpkg.com/@fontsource/barlow-condensed@4.5.0/files/barlow-condensed-latin-700-normal.woff',
];

async function fetchFont(urls){
  for(var i=0;i<urls.length;i++){
    try{
      var res=await fetch(urls[i],{mode:'cors'});
      if(!res.ok){console.warn('HTTP',res.status,urls[i]);continue;}
      var buf=await res.arrayBuffer();
      return opentype.parse(buf);
    }catch(e){console.warn('Font load failed:',urls[i],e.message);}
  }
  return null;
}

async function loadFonts(){
  var results=await Promise.all([fetchFont(CINZEL_URLS),fetchFont(SANS_URLS)]);
  fonts.cinzel=results[0]; fonts.sans=results[1];
  if(fonts.cinzel||fonts.sans){
    document.getElementById('dlBtn').disabled=false;
    document.getElementById('dlBtn').textContent='\u2193 Download Laser SVG';
  } else {
    document.getElementById('dlBtn').disabled=false;
    document.getElementById('dlBtn').textContent='\u2193 Download SVG (text mode)';
  }
  update();
}

function activeFont(){
  return fonts[state.fontId]||fonts.cinzel||fonts.sans||null;
}

function textToPath(text,cx,baselineY,fontSize,lsSVG){
  var font=activeFont();
  if(!font||!text)return'';
  var lsEm=(lsSVG||0)/fontSize;
  var opts={letterSpacing:lsEm};
  var probe=font.getPath(text,0,0,fontSize,opts);
  var bb=probe.getBoundingBox();
  var startX=cx-(bb.x2-bb.x1)/2-bb.x1;
  return font.getPath(text,startX,baselineY,fontSize,opts).toPathData(3);
}

function applyTranslate(d,dx,dy){
  if(!dx&&!dy) return d;
  var xIdx={M:[0],L:[0],H:[0],C:[0,2,4],S:[0,2],Q:[0,2],T:[0],A:[5]};
  var yIdx={M:[1],L:[1],V:[0],C:[1,3,5],S:[1,3],Q:[1,3],T:[1],A:[6]};
  var cmdArgs={M:2,m:2,L:2,l:2,H:1,h:1,V:1,v:1,C:6,c:6,S:4,s:4,Q:4,q:4,T:2,t:2,A:7,a:7,Z:0,z:0};
  var tokens=d.match(/[MmLlHhVvCcSsQqTtAaZz]|[-+]?(?:\d+\.?\d*|\.\d+)(?:[eE][-+]?\d+)?/g);
  if(!tokens) return d;
  var out=[];
  var cmd='',upper='',argIdx=0,argsPerCmd=0;
  for(var i=0;i<tokens.length;i++){
    var tok=tokens[i];
    if(/^[MmLlHhVvCcSsQqTtAaZz]$/.test(tok)){
      cmd=tok; upper=tok.toUpperCase(); argIdx=0;
      argsPerCmd=cmdArgs[cmd]||0;
      out.push(tok);
    } else {
      var num=parseFloat(tok);
      var abs=(cmd===cmd.toUpperCase());
      var pos=argsPerCmd>0?argIdx%argsPerCmd:0;
      var xi=xIdx[upper]||[]; var yi=yIdx[upper]||[];
      if(abs&&dx&&xi.indexOf(pos)>=0){
        out.push((num+dx).toFixed(3).replace(/\.?0+$/,''));
      } else if(abs&&dy&&yi.indexOf(pos)>=0){
        out.push((num+dy).toFixed(3).replace(/\.?0+$/,''));
      } else {
        out.push(tok);
      }
      argIdx++;
    }
  }
  return out.join(' ');
}

function paperUnite(pathDStrings){
  paper.project.clear();
  var result=null;
  for(var i=0;i<pathDStrings.length;i++){
    var d=pathDStrings[i];
    if(!d) continue;
    var cp=new paper.CompoundPath(d);
    cp.fillColor='black';
    cp.fillRule='nonzero';
    result=result?result.unite(cp,{insert:false}):cp;
  }
  if(!result) return '';
  var svgEl=result.exportSVG({asString:false});
  var pathEl=svgEl.tagName.toLowerCase()==='path'?svgEl:svgEl.querySelector('path');
  var d=pathEl?pathEl.getAttribute('d'):(svgEl.getAttribute('d')||'');
  paper.project.clear();
  return d;
}

function update(){
  var nameUpper=(document.getElementById('ni').value||'NAME').toUpperCase().trim();
  var nameFontSize=BASE_NAME_FS*state.szPct/100;
  var ny=NAME_BASE_Y+state.offsetY;
  var svg=document.getElementById('boardSvg');
  var nameEl=document.getElementById('nameTxt');
  var namePathEl=document.getElementById('namePathEl');
  var font=activeFont();
  if(font){
    var pd=textToPath(nameUpper,NAME_CENTER_X+state.nameDX,ny,nameFontSize,state.letterSpacing);
    if(!namePathEl){
      namePathEl=document.createElementNS('http://www.w3.org/2000/svg','path');
      namePathEl.id='namePathEl';
      namePathEl.setAttribute('fill','#1a1a1a');
      svg.insertBefore(namePathEl,document.getElementById('class2026Group'));
    }
    namePathEl.setAttribute('d',pd);
    namePathEl.style.display='';
    if(nameEl) nameEl.style.display='none';
  } else {
    if(namePathEl) namePathEl.style.display='none';
    if(nameEl){
      nameEl.style.display='';
      nameEl.textContent=nameUpper;
      nameEl.setAttribute('y',ny);
      nameEl.setAttribute('font-size',nameFontSize);
      nameEl.setAttribute('letter-spacing',state.letterSpacing);
    }
  }

  document.getElementById('class2026Group').setAttribute(
    'transform','translate('+CLASS_DEFAULT_DX+','+state.yearDY+')'
  );
  document.getElementById('grad1Group').setAttribute(
    'transform','translate('+(GRAD1_DEFAULT_DX+state.grDX)+',0)'
  );

  // Stake: follows yearDY so pick stays locked to class2026 bottom
  var stakeGroup=document.getElementById('stakeGroup');
  if(stakeGroup){
    stakeGroup.style.display=state.stakeOn?'':'none';
    // Shift stake by same delta applied to class2026 band
    var stakeDY=state.yearDY-CLASS_DEFAULT_DY;
    stakeGroup.setAttribute('transform','translate(0,'+stakeDY+')');
  }

  // Expand viewBox height when stake is visible, accounting for yearDY shift
  var vh=VIEWBOX_H_BASE;
  if(state.stakeOn){
    var stakeTipY=553.0+STAKE_TIP_OFFSET+(state.yearDY-CLASS_DEFAULT_DY);
    vh=Math.ceil(stakeTipY-VIEWBOX_Y+20);
    if(vh<VIEWBOX_H_BASE) vh=VIEWBOX_H_BASE;
  }
  svg.setAttribute('viewBox',VIEWBOX_X+' '+VIEWBOX_Y+' '+VIEWBOX_W+' '+vh);

  var wMM=Math.round(VIEWBOX_W*SVG_TO_MM);
  var hMM=Math.round(vh*SVG_TO_MM);
  document.getElementById('dimHint').textContent=wMM+' x '+hMM+' mm';
}

function buildExportSVG(){
  var nameUpper=(document.getElementById('ni').value||'NAME').toUpperCase().trim();
  var nameFontSize=BASE_NAME_FS*state.szPct/100;
  var ny=NAME_BASE_Y+state.offsetY;
  var vh=VIEWBOX_H_BASE;
  if(state.stakeOn){
    var stakeTipY=553.0+STAKE_TIP_OFFSET+(state.yearDY-CLASS_DEFAULT_DY);
    vh=Math.ceil(stakeTipY-VIEWBOX_Y+20);
    if(vh<VIEWBOX_H_BASE) vh=VIEWBOX_H_BASE;
  }
  var wMM=(VIEWBOX_W*SVG_TO_MM).toFixed(1);
  var hMM=(vh*SVG_TO_MM).toFixed(1);
  var vb=VIEWBOX_X+' '+VIEWBOX_Y+' '+VIEWBOX_W+' '+vh;
  var font=activeFont();
  if(font){
    var namePath=textToPath(nameUpper,NAME_CENTER_X+state.nameDX,ny,nameFontSize,state.letterSpacing);
    var classShifted=applyTranslate(CLASS2026_PATH,CLASS_DEFAULT_DX,state.yearDY);
    var grShifted=applyTranslate(GRAD1_PATH,GRAD1_DEFAULT_DX+state.grDX,0);
    var paths=[grShifted,namePath,classShifted];
    if(state.stakeOn){
      // Shift stake by same yearDY delta to stay connected to class2026 bottom
      var stakeDY=state.yearDY-CLASS_DEFAULT_DY;
      paths.push(applyTranslate(STAKE_PATH,0,stakeDY));
    }
    var unitedD=paperUnite(paths);
    return '<?xml version="1.0" encoding="utf-8"?>'
      +'\n<!-- Graduation Laser-Cut SVG | '+wMM+' x '+hMM+' mm | Boolean-united single path'+(state.stakeOn?' | Cake topper pick included':'')+' -->'
      +'\n<svg version="1.1" xmlns="http://www.w3.org/2000/svg"'
      +' width="'+wMM+'mm" height="'+hMM+'mm" viewBox="'+vb+'">'
      +'\n  <path fill="#000000" d="'+unitedD+'"/>'
      +'\n</svg>';
  }
  // Fallback: font unavailable
  var grShifted=applyTranslate(GRAD1_PATH,GRAD1_DEFAULT_DX+state.grDX,0);
  var stakeDY=state.yearDY-CLASS_DEFAULT_DY;
  return '<?xml version="1.0" encoding="utf-8"?>'
    +'\n<!-- WARNING: Font unavailable. In Inkscape: select text, Path > Object to Path before cutting -->'
    +'\n<svg version="1.1" xmlns="http://www.w3.org/2000/svg"'
    +' width="'+wMM+'mm" height="'+hMM+'mm" viewBox="'+vb+'">'
    +'\n  <path fill="#000000" d="'+grShifted+'"/>'
    +'\n  <text x="'+(NAME_CENTER_X+state.nameDX)+'" y="'+ny+'" text-anchor="middle"'
    +' font-family="Arial,Helvetica,sans-serif" font-weight="700" font-size="'+nameFontSize+'"'
    +' fill="#000000" letter-spacing="'+state.letterSpacing+'">'+nameUpper+'</text>'
    +'\n  <g transform="translate('+CLASS_DEFAULT_DX+','+state.yearDY+')">'
    +'\n    <path fill="#000000" d="'+CLASS2026_PATH+'"/>'
    +'\n  </g>'
    +(state.stakeOn?'\n  <path fill="#000000" d="'+applyTranslate(STAKE_PATH,0,stakeDY)+'"/>':"")
    +'\n</svg>';
}

function stepper(incId,decId,valId,getVal,setVal,fmt,step,min,max){
  document.getElementById(incId).addEventListener('click',function(){
    setVal(Math.min(getVal()+step,max));
    document.getElementById(valId).textContent=fmt(getVal());
    update();
  });
  document.getElementById(decId).addEventListener('click',function(){
    setVal(Math.max(getVal()-step,min));
    document.getElementById(valId).textContent=fmt(getVal());
    update();
  });
}

stepper('szUp','szDown','szVal',function(){return state.szPct;},function(v){state.szPct=v;},function(v){return v+'%';},5,30,200);
stepper('lsUp','lsDown','lsVal',function(){return state.letterSpacing;},function(v){state.letterSpacing=v;},function(v){var d=v+15;return (d>0?'+':'')+d;},1,-45,15);
stepper('nxRight','nxLeft','nxVal',function(){return state.nameDX;},function(v){state.nameDX=v;},function(v){return Math.round(v*SVG_TO_MM)+' mm';},MM_TO_SVG*2,-300,300);
stepper('yDown','yUp','yVal',function(){return state.offsetY;},function(v){state.offsetY=v;},function(v){return Math.round(v*SVG_TO_MM)+' mm';},MM_TO_SVG*2,-200,200);
stepper('cyDown','cyUp','cyVal',function(){return state.yearDY;},function(v){state.yearDY=v;},function(v){var d=v-CLASS_DEFAULT_DY,mm=Math.round(d*SVG_TO_MM);return(mm>=0?'+':'')+mm+' mm';},MM_TO_SVG*2,-100,400);
stepper('grRight','grLeft','grVal',function(){return state.grDX;},function(v){state.grDX=v;},function(v){return Math.round(v*SVG_TO_MM)+' mm';},MM_TO_SVG*2,-200,200);

document.getElementById('fontCinzel').addEventListener('click',function(){
  state.fontId='cinzel';
  document.getElementById('fontCinzel').classList.add('active');
  document.getElementById('fontSans').classList.remove('active');
  update();
});
document.getElementById('fontSans').addEventListener('click',function(){
  state.fontId='sans';
  document.getElementById('fontSans').classList.add('active');
  document.getElementById('fontCinzel').classList.remove('active');
  update();
});

document.getElementById('stakeToggle').addEventListener('click',function(){
  state.stakeOn=!state.stakeOn;
  this.textContent=state.stakeOn?'\u2713 Pick added':'+ Add pick';
  this.classList.toggle('active',state.stakeOn);
  update();
});

document.getElementById('ni').addEventListener('input',update);

document.getElementById('dlBtn').addEventListener('click',function(){
  var btn=document.getElementById('dlBtn');
  btn.disabled=true;
  btn.textContent='Uniting paths\u2026';
  setTimeout(function(){
    try{
      var svgStr=buildExportSVG();
      var blob=new Blob([svgStr],{type:'image/svg+xml;charset=utf-8'});
      var url=URL.createObjectURL(blob);
      var a=document.createElement('a');
      a.href=url;
      a.download='graduation-'+(document.getElementById('ni').value.toLowerCase().replace(/[^a-z0-9]/g,'-')||'custom')+(state.stakeOn?'-pick':'')+'.svg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }catch(err){
      console.error('Export error:',err);
      alert('Export failed: '+err.message);
    }
    btn.disabled=false;
    btn.textContent=activeFont()?'\u2193 Download Laser SVG':'\u2193 Download SVG (text mode)';
  },50);
});

update();
loadFonts();